export default __webpack_public_path__ + "static/media/Arrow.9b8912b5.gif";